import React from 'react'
import { makeStyles } from '@mui/styles'
import { Typography } from '@mui/material'

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  sub: {
    opacity: 0.5,
  },
  childrenContainer: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'center',
  },
}))

const NoSite = props => {
  const classes = useStyles(props)
  const { heading, body, children } = props

  return (
    <div className={classes.container}>
      <Typography variant="h3" className={classes.parent}>
        {heading}
      </Typography>
      <Typography variant="body1" className={classes.sub}>
        {body}
      </Typography>
      {children && <div className={classes.childrenContainer}>{children}</div>}
    </div>
  )
}

export default NoSite
